import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { PlaygroundNavParams } from '@euler/playground/Index';
import { useNavigation } from '@react-navigation/core';
import { HeaderBackButton } from '@react-navigation/elements';
import { StackActions } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { ScrollView, Text } from 'react-native';
import styled from 'styled-components/native';

const PlaygroundItem = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  margin: 8px 32px;
  padding: 16px;
  background-color: #ccc;
  border-radius: 5px;
`;

export const PlaygroundListScreen = wrapNavigatorScreen(
  () => {
    const appNavigation = useAppNavigation();
    const navigation =
      useNavigation<StackNavigationProp<PlaygroundNavParams>>();
    return (
      <ScrollView contentContainerStyle={{ paddingTop: 20 }}>
        <Text style={{ marginHorizontal: 32, marginBottom: 12 }}>
          APDM workflow tools
        </Text>
        <PlaygroundItem
          onPress={() => appNavigation.navigate('ApdmImport', {})}
        >
          <Text>客户资料导入</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => appNavigation.navigate('ApdmCampaignWizard', {})}
        >
          <Text>创建客户触达活动</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => appNavigation.navigate('ApdmDashboard', {})}
        >
          <Text>客户触达活动</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => appNavigation.navigate('ApdmCouponRedemption', {})}
        >
          <Text>优惠券核销</Text>
        </PlaygroundItem>

        <PlaygroundItem onPress={() => navigation.push('BiCharts', {})}>
          <Text>BI 图表样式库</Text>
        </PlaygroundItem>
        <PlaygroundItem onPress={() => navigation.push('BiVisualization', {})}>
          <Text>BI visualization widget</Text>
        </PlaygroundItem>
        <PlaygroundItem onPress={() => navigation.push('BiDashboards', {})}>
          <Text>BI dashboards</Text>
        </PlaygroundItem>
        <PlaygroundItem onPress={() => navigation.push('BiUploads', {})}>
          <Text>BI uploads and data library</Text>
        </PlaygroundItem>
        <PlaygroundItem onPress={() => navigation.push('Score', {})}>
          <Text>Score Gauge</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() =>
            navigation.push('KeyboardAvoidingViewWithScrollViewDemo', {})
          }
        >
          <Text>KeyboardAvoidingView w/ ScrollView</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() =>
            navigation.push('KeyboardAvoidingViewWithFlexDemo', {})
          }
        >
          <Text>KeyboardAvoidingView w/ Flex</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => navigation.push('FreeDrawingWithSvg', {})}
        >
          <Text>Free Drawing w/ SVG</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => navigation.push('FreeDrawingWithSkia', {})}
        >
          <Text>Free Drawing w/ Skia</Text>
        </PlaygroundItem>
        <PlaygroundItem
          onPress={() => navigation.push('FileUploadProgressDemo', {})}
        >
          <Text>File Upload Progress Report Demo</Text>
        </PlaygroundItem>
      </ScrollView>
    );
  },
  // Opened straight from /playground there is nothing beneath it to go
  // back to: the back button then replaces it with the workbench.
  ({ navigation }) => ({
    headerShown: true,
    title: 'Playground',
    headerLeft: props => (
      <HeaderBackButton
        {...props}
        onPress={() =>
          navigation.canGoBack()
            ? navigation.goBack()
            : navigation.getParent()?.dispatch(StackActions.replace('Main'))
        }
      />
    ),
  }),
);
